import { Controller } from '@hotwired/stimulus'

export class EquipmentCardController extends Controller {
  static targets = ['image', 'name', 'serialNumber', 'serialNumberContainer']
  static values = {
    defaultImage: String,
    defaultName: String,
  }

  declare readonly imageTarget: HTMLImageElement
  declare readonly nameTarget: HTMLElement
  declare readonly serialNumberTarget: HTMLElement
  declare readonly serialNumberContainerTarget: HTMLElement

  declare readonly defaultImageValue: string
  declare readonly defaultNameValue: string

  updateEquipmentId({ detail: { value } }) {
    if (value) {
      fetch(`/devices/${value}.json`)
        .then((resp) => resp.json())
        .then(({ device }) => {
          this.imageTarget.src = device.image
          this.nameTarget.innerHTML = device.identifier

          if (device.serial_number) {
            this.serialNumberContainerTarget.classList.remove('hidden')
            this.serialNumberTarget.innerHTML = device.serial_number
          } else {
            this.serialNumberContainerTarget.classList.add('hidden')
            this.serialNumberTarget.innerHTML = ''
          }
        })
    } else {
      this.imageTarget.src = this.defaultImageValue
      this.nameTarget.innerHTML = this.defaultNameValue
      this.serialNumberContainerTarget.classList.add('hidden')
      this.serialNumberTarget.innerHTML = ''
    }
  }
}
